// Header coming from cloudflare request transform rules
export const MARKET_COUNTRY_CODE = 'bm-market'
// Deprecated header coming from experiments worker
export const DEPRECATED_HEADER_CFWORKER_COUNTRY = 'bm-country'
